






import Vue from "vue";

export default Vue.extend({
  name: "Startpage",
  mounted() {
    Vue.set(this.$root.$data, "title", "Startseite");
  },
  computed: {
    text(): string {
      return this.$root.$data.user
        ? "Willkommen auf der Plattform!"
        : "Bitte einloggen.";
    }
  }
});
